/* tslint:disable */
import {
  UserProfile,
  ChartOfAccount,
  PaymentMethods,
  PropertyBills
} from '../index';

declare var Object: any;
export interface VendorPaymentsInterface {
  "amount_paid": string;
  "date_paid": Date;
  "memo"?: string;
  "ref_no"?: string;
  "expenditure_tag"?: string;
  "id"?: number;
  "vendor_id"?: number;
  "chart_of_accounts_id"?: number;
  "payment_method_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "propertyBillsId"?: number;
  userProfile?: UserProfile;
  chartOfAccount?: ChartOfAccount;
  paymentMethods?: PaymentMethods;
  propertyBills?: PropertyBills;
}

export class VendorPayments implements VendorPaymentsInterface {
  "amount_paid": string;
  "date_paid": Date;
  "memo": string;
  "ref_no": string;
  "expenditure_tag": string;
  "id": number;
  "vendor_id": number;
  "chart_of_accounts_id": number;
  "payment_method_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "propertyBillsId": number;
  userProfile: UserProfile;
  chartOfAccount: ChartOfAccount;
  paymentMethods: PaymentMethods;
  propertyBills: PropertyBills;
  constructor(data?: VendorPaymentsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `VendorPayments`.
   */
  public static getModelName() {
    return "VendorPayments";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of VendorPayments for dynamic purposes.
  **/
  public static factory(data: VendorPaymentsInterface): VendorPayments{
    return new VendorPayments(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'VendorPayments',
      plural: 'VendorPayments',
      path: 'VendorPayments',
      idName: 'id',
      properties: {
        "amount_paid": {
          name: 'amount_paid',
          type: 'string'
        },
        "date_paid": {
          name: 'date_paid',
          type: 'Date'
        },
        "memo": {
          name: 'memo',
          type: 'string'
        },
        "ref_no": {
          name: 'ref_no',
          type: 'string'
        },
        "expenditure_tag": {
          name: 'expenditure_tag',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "vendor_id": {
          name: 'vendor_id',
          type: 'number'
        },
        "chart_of_accounts_id": {
          name: 'chart_of_accounts_id',
          type: 'number'
        },
        "payment_method_id": {
          name: 'payment_method_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "propertyBillsId": {
          name: 'propertyBillsId',
          type: 'number'
        },
      },
      relations: {
        userProfile: {
          name: 'userProfile',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'vendor_id',
          keyTo: 'id'
        },
        chartOfAccount: {
          name: 'chartOfAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'chart_of_accounts_id',
          keyTo: 'id'
        },
        paymentMethods: {
          name: 'paymentMethods',
          type: 'PaymentMethods',
          model: 'PaymentMethods',
          relationType: 'belongsTo',
                  keyFrom: 'payment_method_id',
          keyTo: 'id'
        },
        propertyBills: {
          name: 'propertyBills',
          type: 'PropertyBills',
          model: 'PropertyBills',
          relationType: 'belongsTo',
                  keyFrom: 'propertyBillsId',
          keyTo: 'id'
        },
      }
    }
  }
}
